<div class="gl-popup__title">
  {{ title | translate }}
</div>
<div class="gl-popup__close" (click)="closeCsvModal()">
  <span class="glicon-close"></span>
</div>
<ng-content></ng-content>
<div class="margin-top margin-bottom">
  <gl-checkbox
    *ngIf="!selectedFile && isGroup"
    id="reEnrolled"
    small
    [label]="'students.import.reEnrolledLabel' | translate"
    skeletorValueAccessor
    checked
    [(ngModel)]="hasToReEnroll"
  >
  </gl-checkbox>
</div>
<div *ngIf="!selectedFile" dropzone (dropped)="onGetFile($event)" class="gl-popup__upload">
  <span class="glicon-upload-document"></span>
  <span class="label">{{ 'actions.dragAndDropCsv' | translate }}</span>
  <input id="uploadCsv" type="file" name="uploadCsv" class="upload-img" accept=".csv" (change)="onGetFile($event)" />
  <label for="uploadCsv" class="link">
    ó &nbsp;<a class="linkUpload">{{ 'actions.uploadCsv' | translate }}</a></label
  >
  <span class="separator"></span>
  <span class="label small size-file" [ngClass]="{ kepler: isKepler }">{{
    'actions.csvConfigSizeFile' | translate
  }}</span>
  <span *ngIf="!isKepler && !isMars" class="link"
    ><a (click)="isEmailChange ? downloadCsvForEmail() : downloadCsv()">{{
      'actions.downloadCsvTemplate' | translate
    }}</a></span
  >
  <span *ngIf="isMars" class="link"
    ><a (click)="downloadCsvForMars()">{{ 'actions.downloadCsvTemplate' | translate }}</a></span
  >
</div>
<div *ngIf="selectedFile" class="gl-popup__upload--selected">
  <div class="gl-popup__file--upload">
    <div class="gl-popup__file--upload__progress">
      <div class="gl-popup__file--upload__info">
        <div class="name">
          <span class="glicon-upload-document"></span>
          <span>{{ csvData.name }}</span>
        </div>
        <div class="load" [ngClass]="{ success: true }">
          <span>100%</span>
          <!-- <span *ngIf="!loading" class="glicon-close-circle"></span> -->
          <span class="glicon-check-circle"></span>
        </div>
      </div>
      <div class="gl-popup__file--upload__loader">
        <span style="width: 100%"></span>
      </div>
    </div>
    <div class="gl-popup__file--upload__delete" (click)="deleteFile()">
      <span class="glicon-trash"></span>
    </div>
  </div>
</div>
<div class="gl-popup__buttons padding-top__large">
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="closeCsvModal()"></gl-button>
  <gl-button
    color-primary
    [text]="buttonText | translate"
    [disabled]="!selectedFile"
    (onClick)="onSaveCsv()"
  ></gl-button>
</div>
